// extracted by mini-css-extract-plugin
export default {"wrap":"video_wrap__G9awJ","player":"video_player__IJ9vu","cc":"video_cc__yWLzm","controls":"video_controls__EOuyt","icon":"video_icon__jszFN"};